import { useSelector } from 'react-redux';
import { Store, useAppDispatch } from 'src/redux/Store';
import { ENTITIES, ORDER, QuerbuilderPayloadColumns } from 'src/models/QuerybuilderModel';
import Datagrid from 'src/components/Datagrid/Datagrid';
import { useEffect } from 'react';
import {
  getEntitiesAction,
  setColumns,
  setFilters,
  setOrders,
  setQueryBuilderResult,
} from 'src/redux/actions/querybuilderActions';
import DEFAULT_COLUMNS from 'src/constants/columns';
import { resetSelections } from 'src/redux/actions/selectionActions';
import { SEARCH_OPERATORS_PRIMITIVE } from 'src/constants/SearchOperators';
import { getSubscriptionAction } from 'src/redux/actions/subscriptionActions';
import SubscriptionDatagridHeader
  from 'src/components/DatagridToolbar/entities/SubscriptionDatagridHeader';
import PaymentInvoiceToolbar
  from 'src/components/DatagridToolbar/entities/PaymentInvoiceToolbar';

const PaymentsForSubscriptionDatagrid = () => {
  const dispatch = useAppDispatch();
  const subscriptionId = useSelector((state: Store) => Number(state.route.id || 0));

  useEffect(() => {
    dispatch(getSubscriptionAction(subscriptionId));
  }, [subscriptionId]);

  useEffect(() => {
    if (!subscriptionId) return;
    dispatch(setColumns({
      entity: ENTITIES.payments,
      columns: DEFAULT_COLUMNS.paymentsForInvoice,
    } as QuerbuilderPayloadColumns));
    dispatch(setOrders({
      entity: ENTITIES.payments,
      order: [['payments.id', ORDER.desc]],
    }));
    dispatch(setFilters({
      entity: ENTITIES.payments,
      filters: {
        and: [['payments.recurring_id', SEARCH_OPERATORS_PRIMITIVE.eq, subscriptionId]],
      },
    }));
    dispatch(resetSelections({ entity: ENTITIES.payments }));
    dispatch(setQueryBuilderResult({
      entity: ENTITIES.payments,
      result: {
        count: 0,
        list: [],
      },
    }));
    dispatch(getEntitiesAction(ENTITIES.payments));
  }, [subscriptionId]);

  return (
    <>
      <SubscriptionDatagridHeader titleKey="menus.payments_for_subscription" />
      <PaymentInvoiceToolbar />
      <Datagrid entity={ENTITIES.payments} dontReloadEntities />
    </>
  );
};

export default PaymentsForSubscriptionDatagrid;
